import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const NxaFAQIndex = () => {
  const [openQuestions, setOpenQuestions] = useState({});
  const [isMobile, setIsMobile] = useState(false);

  // ✅ Corrected useEffect (moved outside the function)
  useEffect(() => {
    const checkScreenSize = () => setIsMobile(window.innerWidth <= 768);
    checkScreenSize(); // Initial check
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  // ✅ Fixed toggleQuestion function
  const toggleQuestion = (index) => {
    setOpenQuestions((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  return (
    <div
      className="index-sec-1 pricing-page-faq"
      style={{ paddingBottom: "30px" }}
    >
      <div className="container">
        <h2
          className="font--31 color-293F  fw--400"
          style={{ justifyContent: "center", textAlign: "center" }}
        >
          NxaTel Pricing FAQs
        </h2>
        <div className="row">
          {/* Question 1 */}
          <div className="col-md-4">
            <div
              className="pricing-sec-box d-flex"
              style={{ background: "#ffff" }}
            >
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-boxIndex">
                    <h6 className="text--orange">1</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(1)}
                    aria-expanded={openQuestions[1]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    Can I get a local or international {isMobile ? " " : <br />}
                    business number instantly?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[1] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    Yes! NxaTel provides <strong>instant activation</strong> for
                    local, toll-free, and international business numbers,
                    allowing you to start receiving calls in minutes.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Question 2 */}
          <div className="col-md-4">
            <div
              className="pricing-sec-box d-flex"
              style={{ background: "#ffff" }}
            >
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-boxIndex">
                    <h6 className="text--orange">2</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(2)}
                    aria-expanded={openQuestions[2]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    How does the Virtual
                    {isMobile ? " " : <br />} Receptionist work?
                    {isMobile ? " " : <br />}
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[2] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    Our <strong>AI-powered Virtual Receptionist</strong> routes
                    calls automatically based on your settings. It can direct
                    calls to specific departments, employees, or locations and
                    even handle{" "}
                    <strong>
                      after-hours calls with voicemail-to-email and scheduled
                      callbacks.
                    </strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Question 3 */}
          <div className="col-md-4">
            <div
              className="pricing-sec-box d-flex"
              style={{ background: "#ffff" }}
            >
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-boxIndex">
                    <h6 className="text--orange">3</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(3)}
                    aria-expanded={openQuestions[3]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    Do I need special hardware
                    {isMobile ? " " : <br />}
                    to use Nxatel?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[3] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    No! NxaTel works on <strong>any device</strong>, including
                    mobile phones, desktops, and IP phones. You can manage calls
                    through our
                    <strong>web and mobile apps</strong> without additional
                    hardware.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row ">
          {/* Question 4 */}
          <div className="col-md-4">
            <div
              className="pricing-sec-box d-flex"
              style={{ background: "#ffff" }}
            >
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-boxIndex">
                    <h6 className="text--orange">4</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(4)}
                    aria-expanded={openQuestions[4]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    Can I keep my existing business{isMobile ? " " : <br />}{" "}
                    number?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[4] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    Yes! You can{" "}
                    <strong>port your existing business number</strong> to
                    NxaTel while enjoying all our advanced call features.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Question 5 */}
          <div className="col-md-4">
            <div
              className="pricing-sec-box d-flex"
              style={{ background: "#ffff" }}
            >
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-boxIndex">
                    <h6 className="number-of-boxIndex">5</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(5)}
                    aria-expanded={openQuestions[5]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    What happens if I{isMobile ? " " : <br />}
                    miss a call?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[5] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    NxaTel ensures you{" "}
                    <strong>never miss an opportunity</strong> with:
                    <br />
                    <ul
                      style={{
                        listStyleType: " disc",
                      }}
                    >
                      <li>
                        Voicemail-to-Email for<strong> quick follow-ups</strong>
                      </li>
                      <li>
                        <strong>Scheduled Callbacks</strong> to automatically
                        reconnect with missed callers.
                      </li>
                      <li>
                        <strong>Call Assignments & Notes</strong> so your team
                        stays informed
                      </li>
                    </ul>
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Question 6 */}
          <div className="col-md-4">
            <div
              className="pricing-sec-box d-flex"
              style={{ background: "#ffff" }}
            >
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-boxIndex">
                    <h6 className="text--orange">6</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(6)}
                    aria-expanded={openQuestions[6]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    Does NxaTel support
                    {isMobile ? " " : <br />} international calling?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[6] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    Absolutely! You can make and receive{" "}
                    <strong>high-quality international calls</strong> with
                    secure, compliant business numbers in over{" "}
                    <strong>20+ countries.</strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NxaFAQIndex;
